<template>
  <div class="p--40px">
    <h1 class="font--32px lh--1 pb--20px">게시판 관리</h1>
    <table class="table OPTION spacing--lg style--bg font--md">
      <thead>
        <tr>
          <th class="lv--2 w--sm">번호</th>
          <th class="lv--1">게시판ID</th>
          <th class="lv--1">게시판명</th>
          <!-- <th class="lv--1">게시판 부제</th> -->
          <th class="lv--2 w--lg">생성일</th>
          <th class="lv--2 w--md">필수</th>
          <th class="lv--2 w--md">상태</th>
        </tr>
      </thead>

      <tbody>
        <tr
          :key="row.seq"
          v-for="row in boardMetas.rows"
        >
          <td class="lv--2 w--sm">{{row.seq}}</td>
          <td class="lv--1">
            <router-link :to="{name: 'adminBoardMetaEdit', params: {'boardId': row.boardId}}">{{row.boardId}}</router-link>
          </td>
          <td class="lv--1">{{row.boardName}}</td>
          <!-- <td class="lv--1">{{row.boardDeco}}</td> -->
          <td class="lv--2 w--lg text--center">{{row.createdAt | dateFmt14}}</td>
          <td class="lv--2 w--md">{{row.defaultFlag}}</td>
          <td class="lv--2 w--md">{{row.useFlag}}</td>
        </tr>
      </tbody>
    </table>

    <div class="text--center pt--30px">
      <pagination :total="boardMetas.count" />
    </div>

    <div class="text--right pt--30px clearfix">
      <div class="float--right">
        <form-button
          label="게시판 등록"
          class="btn--md deep-orange accent--3 text--white"
          @click="$router.push({name: 'adminBoardMetaCreate'})"
        ></form-button>
      </div>
    </div>

  </div>

</template>

<script>
// import moment from 'moment'
export default {
  data () {
    return {
      selected: false,
      boardMetas: {
        count: 0,
        rows: []
      }
    }
  },
  created () {
    this.search()
  },
  methods: {
    async search () {
      this.boardMetas = await this.$search('/api/board-metas')
    }
  },
  components: {
    Pagination: () => import('@/component/ui2/pagination/Pagination'),
    FormButton: () => import('@/component/ui2/button/FormButton')
    // OrderLink: () => import('@/component/search/OrderLink')
  }
}
</script>
